export default {
  data() {
    return {};
  },
  methods: {
    getAllStationFancesFunction: function (stationId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllStationFences', stationId).then(() => {
        if (this.$store.state.stationFenceModule.successFlag) {
          let temp = this.$store.state.stationFenceModule.allStationFences;
          //station
          if (this.$route.name == 'station') {
            if (temp.length > 0) {
              this.stationHasFance = true;
              this.drawedFanceInfo = temp;
            }
            this.enableFenceModal();
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.stationFenceModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllStationFancesFunction(stationId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.stationFenceModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllStationFancesFunction(stationId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addStationFanceFunction: function () {
      let noFenceFlag = false;
      // if (this.addFanceCordsLatLng.length == 0) {
      //     noFenceFlag = true;
      // }
      let temp = this.addFanceCordsLatLng[0]?.length
        ? this.addFanceCordsLatLng[0]
        : this.polyganData.latlngs?.map((item) => ({
          lat: item[0],
          lng: item[1],
        }));
      if (temp) {
        if (temp.length == 0) {
          noFenceFlag = true;
        }
        if (temp.length < 3) {
          noFenceFlag = true;
        }
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      let data = {
        stationId: this.stationId,
        fenceLocations: [],
      };
      if (noFenceFlag == false) {
        for (let i = 0; i < temp.length; i++) {
          data.fenceLocations.push({
            pointNumber: i + 1,
            latitude: temp[i]?.lat,
            longitude: temp[i]?.lng,
          });
        }
      }
      this.$store.dispatch('addStationFence', data).then(() => {
        if (this.$store.state.stationFenceModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.snackText = ' فنس با موفقیت ثبت شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.stationId = null;
          this.addFanceCordsLatLng = [];
          this.polyganData = {};
          this.stationHasFance = false;
          const map = this.$refs.fancemap.mapObject;
          //map.removeLayer(this.polygon);
          for (let i in map._layers) {
            if (map._layers[i]._path != undefined) {
              try {
                map.removeLayer(map._layers[i]);
              } catch (e) {
                this.snackText = e;
                this.$refs.snackRef.snackModel = true;
                this.snackColor = '#FF5252';
                this.snakIcon = 'mdi-information';
              }
            }
          }
          this.stationFanceModal = false;
          this.getListOfStationsWithPagination();
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.stationFenceModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addStationFanceFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.stationFenceModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addStationFanceFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    removeStationFanceFunction: function () {

      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteStationFence', this.stationId).then(() => {
        if (this.$store.state.stationFenceModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.snackText = ' فنس با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.stationId = null;
          this.addFanceCordsLatLng = [];
          this.polyganData = {};
          this.stationHasFance = false;
          const map = this.$refs.fancemap.mapObject;
          //map.removeLayer(this.polygon);
          for (let i in map._layers) {
            if (map._layers[i]._path != undefined) {
              try {
                map.removeLayer(map._layers[i]);
              } catch (e) {
                this.snackText = e;
                this.$refs.snackRef.snackModel = true;
                this.snackColor = '#FF5252';
                this.snakIcon = 'mdi-information';
              }
            }
          }
          this.stationFanceModal = false;
          this.getListOfStationsWithPagination();
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.stationFenceModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.removeStationFanceFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.stationFenceModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.removeStationFanceFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.stationFenceModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
